import { Box } from '@chakra-ui/react';

export function EvasiveLogo({
  size = { base: '180px', sm: '240px', md: '300px', lg: '360px' },
}: {
  size?: string | Record<string, string>;
}) {
  return (
    <Box
      as="img"
      src="/assets/images/logo.png"
      alt="Evasive.ai"
      w={size}
      maxW="min(400px, 88vw)"
      flexShrink={0}
      objectFit="contain"
    />
  );
}
